import axios from '../../http_v2'
export default {
  add: (params) => {
    return axios.post('activityservice/wechatsign/insert', params)
  },
  update: (params) => {
    return axios.post('activityservice/wechatsign/update', params)
  },
  del: (params) => {
    return axios.post('activityservice/wechatsign/delete', params)
  },
  list: (params) => {
    return axios.post('activityservice/wechatsign/list', params)
  },
  accountList: (params) => {
    // 获取授权公众号
    return axios.post('activityservice/offaccountsetup/list', params)
  },
  signList: (params) => {
    // 获取签到历史
    return axios.post('activityservice/prticipantsearch/signindata', params)
  },
  //签到页
  page: {
    add: (params) => {
      return axios.post('activityservice/signindex/save', params)
    },
    update: (params) => {
      return axios.post('activityservice/signindex/update', params)
    },
    get: (params) => {
      return axios.get('activityservice/signindex/get', params)
    }
  },

  //签到成功页
  success: {
    add: (params) => {
      return axios.post('activityservice/signsuccessconfig/save', params)
    },
    update: (params) => {
      return axios.post('activityservice/signsuccessconfig/update', params)
    },
    get: (params) => {
      return axios.get('activityservice/signsuccessconfig/getbysignid', params)
    }
  },

  // 大屏设置
  screen: {
    add: (params) => {
      return axios.post('activityservice/screenconfig/insert', params)
    },
    update: (params) => {
      return axios.post('activityservice/screenconfig/update', params)
    },
    list: (params) => {
      return axios.post('activityservice/screenconfig/list', params)
    }
  },

  history: {
    list: (params) => {
      return axios.post('activityservice/prticipantsearch/signindata', params)
    }
  }
}
